import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, leftJoin, nullsafe, unionKey } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CancelarFacturaModelForm, validar } from "./form";

type Entity = models.CancelarFacturaModel;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}


/**
* Modal para cancelar una factura
*/
export class CancelarFacturaModal extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));

    onGuardar =  () => {
    this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const hasError = this.hasError(this.props);

        return (
        <kea.Modal
            buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
            onClose={this.onCerrar}
            title="Cancelar factura"
            >

            <CancelarFacturaModelForm onChange={this.props.onChange} value={this.props.value} />
        </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/cancelacion/edit/modal.tsx